export const MATCH_OFFLINE_TYPE = 'offline'
export const MATCH_STATUS_SOON = 'soon'
export const MATCH_STATUS_ENDED = 'ended'
export const MATCH_STATUS_TECHNICAL_DEFEAT = 'technical-defeat'
